import { useState, useEffect } from 'react';
import { Button, Card, Input, message, Modal, Table, Typography } from 'antd';
import { useSelector } from 'react-redux';
import moment from 'moment';
import validator from 'validator';
import SearchBox from '../../components/SearchBox';

import useFetch from '../../_fetch';
import { useDeleteCompany, useGetCompanyWithData } from '../../utils/queryUtils';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import PermissionModal from '../PermissionModal';
import CreateCompany from '../../pages/createCompany';
import { useNavigate } from 'react-router-dom';
import { normalizeString } from '../../utils/pathUtils';


export default function FirmManagement() {
    const { _id } = useSelector(st => st.user);
    const { company = {} } = useSelector((st) => st.selected || {})
    const [permissionModalOpen, setPermissionModalOpen] = useState(null);
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState('');
    const [companies, setCompanies] = useState([]);
    const [showResetPassword, setShowResetPassword] = useState();
    const { mutateAsync: delete_Company, isSuccess: isDeleteSuccess } = useDeleteCompany()
    const [, setShow] = useState([]);
    const [resetPassword, setResetPssword] = useState();

    const [tableFilters, setTableFilters] = useState({});
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    function selectUser(firm) {
        setSelectedUser(firm);
        setShowModal(true);
    }
    const [currentPage] = useState(1);
    const getAllCompanies = useGetCompanyWithData(_id, currentPage, tableFilters);
    const allCompanies = getAllCompanies?.data;
    const _fetch = useFetch();


    useEffect(() => {
        setCompanies(allCompanies)
    }, [allCompanies])
    const passwordValidator = () => {
        return validator.isStrongPassword(resetPassword);
    }

    const handleRefetch = () => {
        getAllCompanies.refetch();
    }

    async function handleResetPassword() {

        if (!passwordValidator()) {
            message.error("Password must be 8 characters long, with at least one uppercase, one lowercase, one number and one symbol");
            return;
        }

        let res = await _fetch(`${process.env.REACT_APP_API_URL}/user/update/password`, {
            method: "PATCH",
            body: {
                new_password: resetPassword,
                user_id: showResetPassword
            }
        })
        let result = await res.json();
        if (res.status === 200) {
            setShowResetPassword();
            setResetPssword();
            message.success("Password reset successfully");
        } else {
            setResetPssword();
            message.error(result.response);
        }
    }

    const columns = [
        {
            title: "Firm Name",
            key: "name",
            width: "25%",
            render: (record) => (
                <div >
                    <p>{record?.name}</p>
                </div>
            )
        },
        {
            title: "Users associated",
            key: "totalUsers",
            width: "15%",
            dataIndex: "totalUsers",
            render: (record) => {
                return <div className='cursor-pointer hover:bg-gray-100 p-2'>
                    <p>{record}</p>
                </div>
            },
            onCell: (record) => {
                return {
                    onClick: (event) => {
                        navigate(`/${record?.name}/users`);
                    },
                }
            },

        },
        {
            title: "Entities",
            key: "totalEntities",
            width: "15%",
            dataIndex: "totalEntities",
            onCell: (record) => {
                return {
                    onClick: (event) => {
                        navigate(
                            `/${record?.name}/entities`
                        );
                    },
                }
            },
        },
        {
            title: "Created On",
            key: "createdAt",
            dataIndex: "createdAt",
            width: "15%",
            render: (text) => moment(text).format('DD MMM YYYY'),
        },
        {
            title: "",
            key: "action",
            width: "20%",
            render: (record) => (
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <Button
                        type="default"
                        onClick={(e) => {
                            e.stopPropagation();
                            setPermissionModalOpen(record);
                        }}
                        danger
                        icon={<DeleteOutlined />}
                        aria-label="Delete Firm"
                    />
                    <Button
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/${normalizeString(record?.name)}/users`);
                        }}
                    >
                        Manage Users
                    </Button>
                    <Button
                        type="default"
                        onClick={(e) => {
                            e.stopPropagation();
                            selectUser(record);
                        }}
                        icon={<EditOutlined />}
                        aria-label="Edit Firm"
                    />
                </div>
            ),
        }




    ];
    useEffect(() => {
        if (allCompanies) {
            setPagination((prev) => ({
                ...prev,
                current: getAllCompanies?.data?.pagination?.current,
                total: getAllCompanies?.data?.pagination?.total,
            }));
        }
    }, [currentPage]);

    async function deleteCompany() {
        try {
            if (company?._id === permissionModalOpen?._id) {
                message.error("Cannot delete current company");
                return
            }
            let res = await delete_Company(permissionModalOpen._id);
            if (res.success || isDeleteSuccess) {
                message.success(`Australian Firm deleted successfully`);
                handleRefetch();
            } else {
                message.error("Error deleting company");
            }
        } catch (err) {
            message.error("Something went wrong");
            console.error(err);
        } finally {
            setPermissionModalOpen(null);
        }
    }

    return (
        <div>
            <Card

                variant="borderless"
                className="circle_box table_space"

                title={
                    <div className="d-flex justify-content-start">


                        <div className="flex-fill search d-flex">
                            <span className="me-3">All Australian Firms</span>
                            <div className="d-flex flex-fill justify-content-center">
                                <SearchBox all={companies} setshow={setShow} name={"Search Australian Firm..."} setFilter={setTableFilters} filterKey={'name'} />
                            </div>
                        </div>
                    </div>
                }
                extra={<Button type='primary'
                    onClick={() => setShowModal(true)}>
                    {"Add Firm"}
                </Button>}
            >
                {
                    // loading ?
                    //     <Loader />
                    //     :
                    <div className="table-responsive">
                        <Table
                            columns={columns}
                            dataSource={companies?.map(e => ({ ...e, key: e._id }))}
                            pagination={{ ...pagination, showSizeChanger: false, }}
                            className="ant-border-space"
                        // onChange={handleTableChange}

                        />
                    </div>
                }
            </Card>
            <CreateCompany visible={showModal}
                setVisible={(val) => {
                    setShowModal(val);
                    if (!val) setSelectedUser('');
                }}
                onSuccess={() => {
                    handleRefetch();
                    setSelectedUser('');
                }}
                isUpdate={!!selectedUser}
                defaultData={selectedUser} />
            <Modal
                title="Reset Password"
                open={showResetPassword ? true : false}
                onCancel={() => {
                    setShowResetPassword()
                    setResetPssword()
                }
                }
                okText="Reset"
                onOk={() => handleResetPassword()}
            >
                <div>
                    <Typography.Text
                    >
                        New Password should be at least 8 character long and must contain at least 1 lowercase character, 1 upper case character, 1 numeric and 1 special symbol.
                    </Typography.Text>
                    <Input placeholder="*******" type='password'
                        className='my-2'
                        autoComplete="new-password"
                        name='resetpassword'
                        value={resetPassword}
                        onChange={(e) => {
                            e.stopPropagation()
                            setResetPssword(e.target.value)
                        }}
                    />
                </div>
            </Modal>

            <PermissionModal
                visible={permissionModalOpen !== null}
                setVisible={setPermissionModalOpen}
                onSuccess={deleteCompany}
                child={
                    <p>
                        Are you sure you want to delete this <b>Australian Firm</b>? This
                        will delete all the <b>Entities</b>, <b>Financial Years</b>,{" "}
                        <b>Queries</b>, and <b>Attachments</b> related to this Australian
                        Firm.
                    </p>
                }
            />
        </div>
    );
}